import React, { useEffect, useState } from "react";
import { Save, Rss } from "lucide-react";
import { adminApi, API } from "../../lib/api";
import { toast } from "sonner";

const FIELDS = [
  { key: "podcast_spotify", label: "Spotify show URL", placeholder: "https://open.spotify.com/show/..." },
  { key: "podcast_apple", label: "Apple Podcasts URL", placeholder: "https://podcasts.apple.com/..." },
  { key: "podcast_youtube", label: "YouTube channel/playlist URL", placeholder: "https://www.youtube.com/@..." },
];

export default function PodcastLinksManager() {
  const [form, setForm] = useState({ podcast_spotify: "", podcast_apple: "", podcast_youtube: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminApi.settings.get().then((d) => setForm((f) => ({ ...f, ...d }))).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.settings.update(form);
      toast.success("Podcast links saved");
    } catch {
      toast.error("Could not save links");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="font-display font-extrabold text-2xl text-navy mb-1">Podcast Subscribe Links</h1>
      <p className="text-slate-500 text-sm mb-8">These appear in the "Never miss an episode" section on the Podcast page. Leave a field blank to hide that button.</p>

      <div className="max-w-xl space-y-5 bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="block text-sm font-semibold text-navy mb-1.5">{f.label}</label>
            <input
              data-testid={`settings-${f.key}`}
              type="url"
              value={form[f.key] || ""}
              onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
              placeholder={f.placeholder}
              className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-orange/40"
            />
          </div>
        ))}
        <button
          data-testid="settings-save-btn"
          onClick={save}
          disabled={saving}
          className="inline-flex items-center gap-2 bg-orange hover:bg-orange-dark disabled:opacity-60 text-white font-bold px-6 py-2.5 rounded-full transition-colors"
        >
          <Save size={16} /> {saving ? "Saving..." : "Save links"}
        </button>
      </div>

      <div className="max-w-xl mt-6 flex items-center gap-3 text-sm text-slate-500">
        <Rss size={16} className="text-orange" />
        <span>Your RSS feed is live at{" "}
          <a href={`${API}/podcast/rss.xml`} target="_blank" rel="noopener noreferrer" className="text-orange font-semibold underline">{API}/podcast/rss.xml</a>
        </span>
      </div>
    </div>
  );
}
